import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import {
  INPUT_MASK_CONFIG2,
  InputMaskConfig
} from './input-mask-custom-config';
import { InputMaskCustomDirective } from './input-mask-custom.directive';

@NgModule({
  declarations: [InputMaskCustomDirective],
  exports: [InputMaskCustomDirective],
  providers: [
    {
      provide: INPUT_MASK_CONFIG2,
      useClass: InputMaskConfig
    }
  ]
})
export class InputMaskCustomModule {
  static forRoot(
    config?: Partial<InputMaskConfig>
  ): ModuleWithProviders<InputMaskCustomModule> {
    return {
      ngModule: InputMaskCustomModule,
      providers: [{ provide: INPUT_MASK_CONFIG2, useValue: config }]
    };
  }
}
